// ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthSession } from './AuthSessionContext';
import { Box, CircularProgress } from '@mui/material';

function ProtectedRoute({ children, allowedRoles }) {
  const { user, roles: userRoles, loading } = useAuthSession();
  const isAuthenticated = Boolean(user);
  // console.log("Protected route ===>", isAuthenticated, userRoles);
  

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (Array.isArray(allowedRoles) && allowedRoles.length > 0) {
    const hasRole = userRoles.some((role) => allowedRoles.includes(role));
    if (!hasRole) {
      return <Navigate to="/no-auth" replace />;
    }
  }

  return children;
}

export default ProtectedRoute;
